<template>
  <v-dialog v-model="dialog" max-width="980" @click:outside="close">
    <v-card>
      <v-card-title class="d-flex align-center">
        <span class="text-h6">{{ $t('tanaoroshiSai.popup.title') }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-6">
        <v-row>
          <v-col cols="12">
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.janCode') }}{{ dialogData.janCode || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.productName') }}{{ dialogData.productName || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.productCode') }}{{ dialogData.productCode || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.colorCode') }}{{ dialogData.colorCode || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.colorName') }}{{ dialogData.colorName || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.sizeCode') }}{{ dialogData.sizeCode || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.sizeName') }}{{ dialogData.sizeName || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('tanaoroshiSai.label.table.planSuuryo') }}：{{ dialogData.planSuuryo ?? '-' }}
            </v-chip>
          </v-col>
        </v-row>

        <v-progress-linear
          v-if="dialogData.loading"
          indeterminate
          color="blue"
          class="mb-4"
        ></v-progress-linear>

        <v-table v-else density="compact" class="text-no-wrap">
          <thead>
            <tr>
              <th>{{ $t('tanaoroshiSai.popup.table.no') }}</th>
              <th>{{ $t('tanaoroshiSai.popup.table.zoneName') }}</th>
              <th>{{ $t('tanaoroshiSai.popup.table.resultSuuryo') }}</th>
              <th v-if="needShowAdjustmentParts()">{{ $t('tanaoroshiSai.popup.table.adjustementSuuryo') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in dialogData.locationList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ row.zoneName || '-' }}</td>
              <td>{{ row.resultSuuryo ?? '-' }}</td>
              <td v-if="needShowAdjustmentParts()">
                <v-text-field density="compact" variant="outlined" hide-details="auto"
                  v-model="adjustmentInfoList[index]" @input="fixAdjustmentQuantity(index, $event)" />
              </td>
            </tr>
            <tr v-if="dialogData.locationList.length === 0">
              <td :colspan="3" class="text-center grey--text">
                {{ $t('tanaoroshiSai.popup.noData') }}
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
      <template v-if="needShowAdjustmentParts()">
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="indigo darken-1" dark @click="save">{{ $t('common.action.save') }}</v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogData: {
      type: Object,
      required: true,
    },
    handleClose: {
      type: Function,
      required: true,
    },
    handleSave: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      dialog: true,
      /** 調整数量を保持 */
      adjustmentInfoList: []
    };
  },
  watch: {
    // ロケ情報の更新を監視
    'dialogData.locationList': {
      handler(newValue) {
        if (!newValue) return;
        this.adjustmentInfoList = new Array(newValue.length);
        // 入力済みデータの復帰処理。ゾーンコードをキーにマッピングする。
        if (!this.dialogData.adjustmentInfo) return;
        for (let i = 0; i < newValue.length; i++) {
          const e = this.dialogData.adjustmentInfo.find(e => e.zoneCode == newValue[i].zoneCode);
          this.adjustmentInfoList[i] = e?.adjustmentQuantity ?? "";
        }
      }
    }
  },
  methods: {
    close() {
      this.handleClose();
    },
    /**
     * 入力された調整数量を保持する
     * @param index 入力された位置(0始まり)
     * @param event 対象のTextBoxのイベント
     */
    fixAdjustmentQuantity(index, event) {
      const val = event.target.value;
      // 正の整数のみを許容する
      this.adjustmentInfoList[index] = val.replace(/[^0-9]/g, '');
    },
    /**
     * 調整情報を対象の行情報に登録する。
     * この時点ではDBに登録されない。
     */
    save() {
      const adjustmentInfo = [];
      for (let i = 0; i < this.dialogData.locationList.length; i++) {
        const adjustmentQuantity = this.adjustmentInfoList[i]
        if (!adjustmentQuantity) continue;
        const location = this.dialogData.locationList[i];
        adjustmentInfo.push({
          zoneCode: location.zoneCode,
          zoneName: location.zoneName,
          resultSuuryo: location.resultSuuryo,
          adjustmentQuantity: adjustmentQuantity
        });
      }
      this.handleSave(adjustmentInfo);
    },
    /**
     * 数量調整関連の表示有無を返却
     */
    needShowAdjustmentParts() {
      return this.dialogData.canAdjustment && this.dialogData.isApvInventory;
    }
  },
};
</script>
